'use client';

import React from 'react';

import { cn } from '@/shared/utils/utils';

interface PulsatingButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  pulseColor?: string;
  duration?: string;
}

export default function PulsatingButton({
  className,
  children,
  pulseColor = '#fbe4b1',
  duration = '5s',
  ...props
}: PulsatingButtonProps) {
  return (
    <button
      className={cn(
        'relative rounded-full text-center h-12 cursor-pointer flex justify-center items-center  text-lg text-gray-900 dark:text-white  px-4 py-2',
        className,
      )}
      style={
        {
          backgroundColor: pulseColor,
          '--pulse-color': pulseColor,
          '--duration': duration,
        } as React.CSSProperties
      }
      {...props}
    >
      <div className="relative z-10">{children}</div>
      {/* Кольцо анимируется через transform/opacity (animate-pulse-ring) —
          box-shadow не композитится на GPU и попадал в аудит Lighthouse */}
      <div className="absolute top-1/2 left-1/2 size-full rounded-full bg-inherit animate-pulse-ring -translate-x-1/2 -translate-y-1/2" />
    </button>
  );
}
